import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import NavbarContextProvider from "./Context/MedianavContext.jsx";
import CourseContextProvider from "./Context/MediatestContext.jsx";
import SpecialtyContextProvider from "./Context/MediatestContext.jsx";

import EnglishPrograms from "./Components/EnglishPrograms/EnglishPrograms.jsx";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <CourseContextProvider>
    <App />
  </CourseContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
